import { render, staticRenderFns } from "./PopupPatient.vue?vue&type=template&id=62fd9549&scoped=true&"
import script from "./PopupPatient.vue?vue&type=script&lang=js&"
export * from "./PopupPatient.vue?vue&type=script&lang=js&"
import style0 from "./PopupPatient.vue?vue&type=style&index=0&id=62fd9549&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fd9549",
  null
  
)

export default component.exports